module.exports = __webpack_public_path__ + "static/media/smoke3Layer.484b30f8.png";